export const removeEmptyParams = (
  params: Record<string, any>
): Record<string, any> => {
  return Object.entries(params).reduce(
    (acc: Record<string, any>, [key, value]) => {
      if (
        value !== undefined &&
        value !== null &&
        value !== "" &&
        !(Array.isArray(value) && value.length === 0)
      ) {
        acc[key] = value; // This should now be type-safe
      }
      return acc;
    },
    {}
  );
};
